import { FormConfig } from "../../../shared/types/legacy";

export const formU: FormConfig = {
    name: {
        type: 'text',
        label: '',
        nombreService: 'name',
        value: '',
        validators: ['required'],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: false,
        disabled: false,
        /*attr: {
            [key: string]: any;
        },*/
    },
    username: {
        type: 'text',
        label: '',
        nombreService: 'username',
        value: '',
        validators: ['required'],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: false,
        disabled: false
    },
    email: {
        type: 'text',
        label: '',
        nombreService: 'email',
        value: '',
        validators: ['required', 'email'],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: false,
        disabled: false
    },
    phone: {
        type: 'int',
        label: '',
        nombreService: 'phone',
        value: '',
        validators: [],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: false,
        disabled: false
    },
    password: {
        type: 'password',
        label: '',
        nombreService: 'password',
        value: '',
        validators: ['required', 'repeat'],
        autocomplete: 'new-password',
        readonly: false,
        options: [],
        hidden: false,
        disabled: false
    },
    passwordRepeat: {
        type: 'password',
        label: '',
        nombreService: 'passwordRepeat',
        value: '',
        validators: ['required', 'repeat'],
        autocomplete: 'new-password',
        readonly: false,
        options: [],
        hidden: false,
        disabled: false
    },
    /*
    nameorga: {
        type: 'text',
        label: '',
        nombreService: 'nameorga',
        value: '',
        validators: ['required'],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: false,
        disabled: false
    },
    cif: {
        type: 'text',
        label: '',
        nombreService: 'cif',
        value: '',
        validators: ['required', 'nifcif'],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: false,
        disabled: false
    },
    emailorga: {
        type: 'text',
        label: '',
        nombreService: 'emailorga',
        value: '',
        validators: ['required', 'email'],
        autocomplete: 'off',
        readonly: false,
        options: null,
        hidden: false,
        disabled: false
    }
    */
}
